import urlJoin from 'url-join';

import HTTPService from './services/HTTPService.es6';
import {
    ADDRESS_GEOTYPE_LABEL,
    BOROUGH_GEOTYPE_LABEL,
    NEIGHBORHOOD_GEOTYPE_LABEL,
    STREET_GEOTYPE_LABEL,
} from './constants.es6';

/**
 * Set URL action in form depending place and realtor name filter
 * @param $form
 * @param place
 * @return {Promise}
 */
export function getSearchFormUrl(place) {
    return new Promise(resolve => {
        if (place.geotype_label === ADDRESS_GEOTYPE_LABEL) {
            $.get(
                urlJoin(MA.Config.GEOAPI_URL, 'addresses', String(place.id)),
                { fields: 'street,city' },
                address => {
                    $.get(
                        urlJoin(
                            MA.Config.GEOAPI_URL,
                            'streets',
                            String(address.response.place.street.id),
                        ),
                        { fields: 'id,slug' },
                        street => {
                            resolve(
                                `${address.response.place.city.slug}/${street.response.place.slug}-${street.response.place.id}/${place.slug}`,
                            );
                        },
                    );
                },
            );
        } else if (place.geotype_label === STREET_GEOTYPE_LABEL) {
            $.get(
                urlJoin(MA.Config.GEOAPI_URL, 'streets', String(place.id)),
                { fields: 'id,slug,city' },
                street => {
                    resolve(
                        `${street.response.place.city.slug}/${street.response.place.slug}-${street.response.place.id}`,
                    );
                },
            );
        } else if (
            place.geotype_label === NEIGHBORHOOD_GEOTYPE_LABEL ||
            place.geotype_label === BOROUGH_GEOTYPE_LABEL
        ) {
            $.get(
                urlJoin(
                    MA.Config.GEOAPI_URL,
                    `${place.geotype_label.toLowerCase()}s`,
                    String(place.id),
                ),
                { fields: 'id,slug,city' },
                data => {
                    resolve(
                        `${data.response.place.city.slug}/quartier_${data.response.place.slug}-${data.response.place.id}`,
                    );
                },
            );
        } else {
            resolve(place.slug);
        }
    });
}

/**
 * Fetch GeoJSON Geom of the parcel of a given place
 *
 * @param {Object} place
 * @return {Promise<GeoJSON>} parcel GeoJSON
 */
export function fetchParcelGeom(place) {
    return HTTPService.getGeo(
        `${urlJoin(MA.Config.PLACE_TYPE_PLURALS[place.geotype_label], String(place.id))}/parcelles`,
        { fields: 'geom_geojson' },
    ).then(({ data }) => data.children[0].geom_geojson);
}

/**
 * Fetch GeoJSON Geom of a given place
 *
 * @param {Object} place
 * @return {Promise<GeoJSON>} place GeoJSON
 */
export function fetchPlaceGeom(place) {
    return HTTPService.getGeo(
        urlJoin(MA.Config.PLACE_TYPE_PLURALS[place.geotype_label], String(place.id)),
        { fields: 'geom2_geojson' },
    ).then(({ data }) => data.place.geom2_geojson);
}

/**
 * returns the hash of the provided string with the provided algorithm
 * @param value value
 * @param algorithm algorithm in `SHA-***` format
 * @returns {Promise<string>}
 */
export const getHash = (value, algorithm) => {
    const utf8 = new TextEncoder().encode(value);
    if (crypto) {
        return crypto.subtle.digest(algorithm, utf8).then(hashBuffer => {
            const hashArray = Array.from(new Uint8Array(hashBuffer));
            return hashArray.map(bytes => bytes.toString(16).padStart(2, '0')).join('');
        });
    }
    return Promise.resolve('');
};
